import * as React from 'react'
  /* @jsx mdx */
import { mdx } from '@mdx-js/react';
/* @jsxRuntime classic */

/* @jsx mdx */

export const _frontmatter = {};
const layoutProps = {
  _frontmatter
};
const MDXLayout = "wrapper";
export default function MDXContent({
  components,
  ...props
}) {
  return <MDXLayout {...layoutProps} {...props} components={components} mdxType="MDXLayout">
    <ul>
      <li parentName="ul"><a parentName="li" {...{
          "href": "/getting-started"
        }}>{`Getting Started`}</a></li>
      <li parentName="ul"><a parentName="li" {...{
          "href": "/props"
        }}>{`Props`}</a></li>
      <li parentName="ul"><a parentName="li" {...{
          "href": "/theming"
        }}>{`Theming`}</a></li>
      <li parentName="ul"><a parentName="li" {...{
          "href": "/variants"
        }}>{`Variants`}</a></li>
      <li parentName="ul"><a parentName="li" {...{
          "href": "/extending"
        }}>{`Extending`}</a></li>
      <li parentName="ul"><a parentName="li" {...{
          "href": "/box"
        }}>{`Box`}</a></li>
      <li parentName="ul"><a parentName="li" {...{
          "href": "/flex"
        }}>{`Flex`}</a></li>
      <li parentName="ul"><a parentName="li" {...{
          "href": "/text"
        }}>{`Text`}</a></li>
      <li parentName="ul"><a parentName="li" {...{
          "href": "/heading"
        }}>{`Heading`}</a></li>
      <li parentName="ul"><a parentName="li" {...{
          "href": "/button"
        }}>{`Button`}</a></li>
      <li parentName="ul"><a parentName="li" {...{
          "href": "/link"
        }}>{`Link`}</a></li>
      <li parentName="ul"><a parentName="li" {...{
          "href": "/image"
        }}>{`Image`}</a></li>
      <li parentName="ul"><a parentName="li" {...{
          "href": "/card"
        }}>{`Card`}</a></li>
      <li parentName="ul"><a parentName="li" {...{
          "href": "/forms"
        }}>{`Forms`}</a>
        <ul parentName="li">
          <li parentName="ul"><a parentName="li" {...{
              "href": "/forms/label"
            }}>{`Label`}</a></li>
          <li parentName="ul"><a parentName="li" {...{
              "href": "/forms/input"
            }}>{`Input`}</a></li>
          <li parentName="ul"><a parentName="li" {...{
              "href": "/forms/select"
            }}>{`Select`}</a></li>
          <li parentName="ul"><a parentName="li" {...{
              "href": "/forms/textarea"
            }}>{`Textarea`}</a></li>
          <li parentName="ul"><a parentName="li" {...{
              "href": "/forms/radio"
            }}>{`Radio`}</a></li>
          <li parentName="ul"><a parentName="li" {...{
              "href": "/forms/checkbox"
            }}>{`Checkbox`}</a></li>
          <li parentName="ul"><a parentName="li" {...{
              "href": "/forms/slider"
            }}>{`Slider`}</a></li>
          <li parentName="ul"><a parentName="li" {...{
              "href": "/forms/switch"
            }}>{`Switch`}</a></li>
        </ul>
      </li>
      <li parentName="ul"><a parentName="li" {...{
          "href": "/layout"
        }}>{`Layout`}</a></li>
      <li parentName="ul"><a parentName="li" {...{
          "href": "/guides"
        }}>{`Guides`}</a>
        <ul parentName="li">
          <li parentName="ul"><a parentName="li" {...{
              "href": "/guides/css-grid"
            }}>{`CSS Grid`}</a></li>
          <li parentName="ul"><a parentName="li" {...{
              "href": "/guides/mdx"
            }}>{`MDX`}</a></li>
          <li parentName="ul"><a parentName="li" {...{
              "href": "/guides/using-rebass-without-context"
            }}>{`Using Rebass without Context`}</a></li>
          <li parentName="ul"><a parentName="li" {...{
              "href": "/guides/server-side-rendering"
            }}>{`Server- Side Rendering`}</a></li>
          <li parentName="ul"><a parentName="li" {...{
              "href": "/guides/styled-components"
            }}>{`Styled Components`}</a></li>
        </ul>
      </li>
      <li parentName="ul"><a parentName="li" {...{
          "href": "/demo"
        }}>{`Demo`}</a></li>
      <li parentName="ul"><a parentName="li" {...{
          "href": "/recipes"
        }}>{`Recipes`}</a>
        <ul parentName="li">
          <li parentName="ul"><a parentName="li" {...{
              "href": "/recipes/flexbox-grid"
            }}>{`Flexbox Grid`}</a></li>
          <li parentName="ul"><a parentName="li" {...{
              "href": "/recipes/flexbox-wrap"
            }}>{`Flexbox Wrap`}</a></li>
          <li parentName="ul"><a parentName="li" {...{
              "href": "/recipes/nav-bar"
            }}>{`Nav Bar`}</a></li>
          <li parentName="ul"><a parentName="li" {...{
              "href": "/recipes/image-card"
            }}>{`Image Card`}</a></li>
          <li parentName="ul"><a parentName="li" {...{
              "href": "/recipes/background-image-card"
            }}>{`Background Image Card`}</a></li>
          <li parentName="ul"><a parentName="li" {...{
              "href": "/recipes/video-embed"
            }}>{`Video Embed`}</a></li>
          <li parentName="ul"><a parentName="li" {...{
              "href": "/recipes/container"
            }}>{`Container`}</a></li>
          <li parentName="ul"><a parentName="li" {...{
              "href": "/recipes/avatar"
            }}>{`Avatar`}</a></li>
          <li parentName="ul"><a parentName="li" {...{
              "href": "/recipes/badge"
            }}>{`Badge`}</a></li>
          <li parentName="ul"><a parentName="li" {...{
              "href": "/recipes/nav-link"
            }}>{`NavLink`}</a></li>
        </ul>
      </li>
    </ul>

    </MDXLayout>;
}
;
MDXContent.isMDXComponent = true;
      